import { render, staticRenderFns } from "./Audios.vue?vue&type=template&id=7e12b2b6&"
import script from "./Audios.vue?vue&type=script&lang=js&"
export * from "./Audios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports